import { render, staticRenderFns } from "./tableAvatar.vue?vue&type=template&id=e4d00e66&scoped=true&"
import script from "./tableAvatar.vue?vue&type=script&lang=js&"
export * from "./tableAvatar.vue?vue&type=script&lang=js&"
import style0 from "./tableAvatar.vue?vue&type=style&index=0&id=e4d00e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d00e66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4d00e66')) {
      api.createRecord('e4d00e66', component.options)
    } else {
      api.reload('e4d00e66', component.options)
    }
    module.hot.accept("./tableAvatar.vue?vue&type=template&id=e4d00e66&scoped=true&", function () {
      api.rerender('e4d00e66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rw/tempTable/components/tableAvatar.vue"
export default component.exports